import { normalizeToastMessage, pushToast } from "../../components/Toast/toastService";

export function getSetupErrorMessage(err, fallback = "Something went wrong.") {
    if (!err) return fallback;
    if (typeof err.setupMessage === "string") return err.setupMessage;

    const fromResponse = normalizeToastMessage(err.response?.data);
    if (fromResponse) return fromResponse;

    const fromError = normalizeToastMessage(err.message);
    if (fromError) return fromError;

    return fallback;
}

export function notifySetupValidation(message) {
    pushToast({ type: "warning", text: message });
}

export function notifySetupPartialSuccess(message) {
    pushToast({ type: "success", text: message });
    return message;
}

export function notifySetupError(step, err) {
    const reason = getSetupErrorMessage(err);
    const text = step ? `${step} failed: ${reason}` : reason;
    pushToast({ type: "error", text });
    return text;
}

export function notifySetupSuccess({ botName, symbol, isEdit = false }) {
    const verb = isEdit ? "updated" : "created";
    const text = `"${botName}" ${verb} on ${symbol}.`;
    pushToast({ type: "success", text });
    return text;
}

export async function runSetupStep(stepName, action) {
    try {
        return await action();
    } catch (err) {
        const message = notifySetupError(stepName, err);
    const wrapped = new Error(message);
    wrapped.cause = err;
    wrapped.setupStep = stepName;
    wrapped.setupNotified = true;
    throw wrapped;
    }
}